"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewDerivateKanban = void 0;
const interfaces_1 = require("../../exports/store/interfaces");
const datasheet_1 = require("../../modules/database/store/selectors/resource/datasheet");
const constants_1 = require("../../modules/shared/store/constants");
const field_1 = require("../../model/field");
const field_types_1 = require("../../types/field_types");
const view_derivate_base_1 = require("./view_derivate_base");
class ViewDerivateKanban extends view_derivate_base_1.ViewDerivateBase {
    constructor(state, datasheetId) {
        super(state, datasheetId);
        this.state = state;
        this.datasheetId = datasheetId;
    }
    getGroupValueMap(field) {
        let sourceData = [];
        if (field.type === field_types_1.FieldType.SingleSelect) {
            sourceData = field.property.options.map(item => item.id);
        }
        else {
            sourceData = field.property.unitIds || [];
        }
        return sourceData.reduce((map, item) => {
            map[item] = [];
            return map;
        }, { [constants_1.UN_GROUP]: [] });
    }
    getKanbanGroupMap(rows, kanbanFieldId) {
        var _a, _b;
        const snapshot = this.state.datasheetMap[this.datasheetId].datasheet.snapshot;
        const fieldPermissionMap = (_a = this.state.datasheetMap[this.datasheetId]) === null || _a === void 0 ? void 0 : _a.fieldPermissionMap;
        if (!kanbanFieldId || !snapshot) {
            return {};
        }
        const recordMap = snapshot.recordMap;
        const fieldRole = (0, datasheet_1.getFieldRoleByFieldId)(fieldPermissionMap, kanbanFieldId);
        const fieldMap = snapshot.meta.fieldMap;
        const field = fieldMap[kanbanFieldId];
        if (fieldRole === interfaces_1.Role.None || !field) {
            return {
                UN_GROUP: rows.map(row => {
                    return recordMap[row.recordId];
                }),
            };
        }
        const groupMap = this.getGroupValueMap(field);
        for (const { recordId } of rows) {
            const record = recordMap[recordId];
            if (!record) {
                console.warn('! ' + `${recordId} is not exist,check kanban data`);
                continue;
            }
            const fieldData = record.data[kanbanFieldId];
            if (fieldData == null) {
                groupMap[constants_1.UN_GROUP].push(record);
                continue;
            }
            try {
                if (field.type === field_types_1.FieldType.Member) {
                    const id = (_b = field_1.MemberField.polyfillOldData(fieldData)) === null || _b === void 0 ? void 0 : _b[0];
                    id && groupMap[id].push(record);
                    continue;
                }
                groupMap[fieldData].push(record);
            }
            catch (e) {
                console.warn('! ' + `${fieldData} is not exist,check kanban data`);
            }
        }
        return groupMap;
    }
    // Sorting under Kanban view.
    getSortRowsByKanbanGroup(view, rows, kanbanGroupMap) {
        var _a, _b;
        const snapshot = (_a = this.state.datasheetMap[this.datasheetId]) === null || _a === void 0 ? void 0 : _a.datasheet.snapshot;
        if (!view || view.type !== constants_1.ViewType.Kanban || !snapshot) {
            return rows;
        }
        const kanbanFieldId = view === null || view === void 0 ? void 0 : view.style.kanbanFieldId;
        if (!kanbanFieldId) {
            return rows;
        }
        const field = snapshot.meta.fieldMap[kanbanFieldId];
        if (!field) {
            return rows;
        }
        const fieldPermissionMap = (_b = this.state.datasheetMap[this.datasheetId]) === null || _b === void 0 ? void 0 : _b.fieldPermissionMap;
        if ((0, datasheet_1.getFieldRoleByFieldId)(fieldPermissionMap, kanbanFieldId) === interfaces_1.Role.None) {
            // kanbanFieldId Permissions have been set and are not visible to the current user, 
            // there is no need to handle the following logic.
            return rows;
        }
        if (!kanbanGroupMap) {
            return rows;
        }
        const groupIds = field.type === field_types_1.FieldType.SingleSelect
            ? field.property.options.map(item => item.id)
            : field.property.unitIds;
        if (!Array.isArray(groupIds)) {
            return rows;
        }
        const flatRows = [constants_1.UN_GROUP, ...groupIds].map(groupId => {
            const kanbanGroup = kanbanGroupMap[groupId];
            if (!kanbanGroup) {
                return [];
            }
            return kanbanGroup.map(record => ({ recordId: record.id }));
        }).flat();
        return flatRows;
    }
    getViewDerivation(view) {
        view = view || (0, datasheet_1.getCurrentView)(this.state);
        const { rowsWithoutSearch } = super.getViewDerivation(view);
        const viewDerivationWithSearch = this.getViewDerivationWithSearch(view, rowsWithoutSearch);
        return Object.assign({ rowsWithoutSearch }, viewDerivationWithSearch);
    }
    getViewDerivationWithSearch(view, rowsWithoutSearch) {
        const kanbanGroupMapWithoutSearch = this.getKanbanGroupMap(rowsWithoutSearch, (0, datasheet_1.getKanbanFieldId)(this.state));
        rowsWithoutSearch = this.getSortRowsByKanbanGroup(view, rowsWithoutSearch, kanbanGroupMapWithoutSearch);
        const { visibleRows, searchResults } = this.getSearchRows(rowsWithoutSearch, view);
        const kanbanGroupMap = this.getKanbanGroupMap(visibleRows, (0, datasheet_1.getKanbanFieldId)(this.state));
        const visibleRowsIndexMap = new Map(visibleRows.map((item, index) => [item.recordId, index]));
        return {
            // Raw rows of data, grouped without any filtering sorting.
            rowsIndexMap: new Map(view.rows.map((item, index) => [item.recordId, index])),
            // Excluding pre-sorted row data, including filtered sorted grouped search
            pureVisibleRows: visibleRows,
            // Map of the row-order data after view property calculation
            pureVisibleRowsIndexMap: visibleRowsIndexMap,
            // Visual row data, including filtering sorting grouping search pre-sorting
            visibleRows,
            // A map with recordId as key and order as value
            visibleRowsIndexMap: visibleRowsIndexMap,
            // Kanban middle properties
            kanbanGroupMap,
            searchResults,
        };
    }
}
exports.ViewDerivateKanban = ViewDerivateKanban;
//# sourceMappingURL=view_derivate_kanban.js.map